import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import NumberDataPod from '../../../components/NumberDataPod';

const TransferUndergraduateEnrollment = ({ transferAdmissions }) => {
  const value = get(transferAdmissions, 'undergraduateEnrollment.value');
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');

  return (
    !Number.isNaN(+value) &&
    +value > 0 && (
      <NumberDataPod
        header={`Transfer Undergraduate Enrollment`}
        tooltip={`Number of full-time undergraduates seeking a degree or certificate who have transferred to this college.`}
        footer={lastUpdated}
        ariaLabel={`Transfer Undergraduate Enrollment, ${value}`}
        content={{
          value: +value,
          linkText: `What you need to know about transferring to this college`,
          linkUrl: 'Transfer',
        }}
      />
    )
  );
};
TransferUndergraduateEnrollment.propTypes = {
  transferAdmissions: PropTypes.object,
};

export default TransferUndergraduateEnrollment;
